export default __webpack_public_path__ + "static/media/parental-leave.a5ec7ca1.svg";